const updates = [
  {
    date: '2026-07-31',
    title: '红桃视频暑期档片单全面上线',
    desc: '涵盖动作、科幻、喜剧、爱情等8大类型的暑期强档影片已更新至红桃视频专区，高清画质即点即看。',
    dot: 'primary',
  },
  {
    date: '2026-07-29',
    title: '西瓜视频免费频道新增500部经典港片',
    desc: '从周星驰喜剧到王家卫文艺片，高清修复版港片全集现已登陆西瓜视频免费频道。',
    dot: 'accent',
  },
  {
    date: '2026-07-27',
    title: '小蓝视频同步上线7月新番动画',
    desc: '本季最受期待的日漫新番已在私密视频小蓝频道上线，中日双语字幕同步更新。',
    dot: 'primary',
  },
  {
    date: '2026-07-24',
    title: '茄子视频独家引进BBC年度纪录片',
    desc: '茄子视频获得BBC年度重磅纪录片独家播放权，涵盖自然、历史、科技等多个系列。',
    dot: 'secondary',
  },
  {
    date: '2026-07-21',
    title: '久久视频经典修复第四批作品发布',
    desc: 'AI修复技术全新升级，第四批200余部经典老片画质焕新，怀旧观影体验全面升级。',
    dot: 'accent',
  },
  {
    date: '2026-07-18',
    title: '芒果视频原创综艺《声入人心》第二季回归',
    desc: '芒果视频独家自制音乐综艺第二季全新升级，每周五晚黄金时段更新，话题热度持续攀升。',
    dot: 'primary',
  },
  {
    date: '2026-07-15',
    title: '全平台播放引擎升级 · 加载速度提升40%',
    desc: '私密视频技术团队完成核心播放引擎全面升级，高清视频加载速度大幅提升，缓冲率降至历史最低。',
    dot: 'secondary',
  },
];

const dotColorMap: Record<string, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-500',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            最新动态
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">
            平台快讯与更新日志
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            关注私密视频最新内容上线与技术动态，不错过任何重要更新
          </p>
        </div>

        <div className="relative max-w-3xl mx-auto">
          <div className="absolute left-[19px] top-3 bottom-3 w-0.5 bg-background-200"></div>
          <div className="space-y-6">
            {updates.map((item, i) => (
              <div key={i} className="relative flex gap-6">
                <div className="relative z-10 flex-shrink-0 mt-1">
                  <div className={`w-[10px] h-[10px] rounded-full ${dotColorMap[item.dot]} ring-4 ring-background-50`}></div>
                </div>
                <div className="flex-1 min-w-0 pb-2">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs text-foreground-400 font-medium whitespace-nowrap">{item.date}</span>
                    <span className="text-xs text-foreground-300">·</span>
                    <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                  </div>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}